import {useSupervisorUserSearch} from '@domain/hroc-checklists'
import {
  AutocompleteProps,
  UserSearchAutocomplete as CommonUserSearchAutocomplete
} from '@hconnect/common/components/formFields'
import type {User} from '@hconnect/common/types'
import React, {useMemo} from 'react'

import {useWidgetTranslation} from '../../hooks'

export type UserSearchAutocompleteProps = Omit<AutocompleteProps<User>, 'options'> & {
  plantId: string
}

export const UserSearchAutocomplete = ({
  value,
  plantId,
  ...otherProps
}: UserSearchAutocompleteProps) => {
  const {t} = useWidgetTranslation()
  const [searchTerm, setSearchTerm] = React.useState<string | undefined>(undefined)

  const {data, isFetching} = useSupervisorUserSearch(plantId, searchTerm)

  const suggestions = useMemo(() => {
    if (Array.isArray(value)) {
      return ((data as User[]) ?? []).filter((user) => !value.find(({id}) => id === user.id))
    } else {
      return ((data as User[]) ?? []).filter((user) => value?.id !== user.id)
    }
  }, [data, value])

  return (
    <CommonUserSearchAutocomplete
      {...otherProps}
      value={value}
      placeholder={t('label.search')}
      onInputChange={setSearchTerm}
      query={{data: suggestions, isFetching}}
    />
  )
}
